import {
    mapFromElementRangeArray,
    TimeSeriesDisableRange,
} from 'utils/timeseries/TimeSeriesDisableRange.ts';
import { useVolumeCurveWidgetStreamedData } from 'widgets/volumeCurve/hooks/useVolumeCurveStreamedData.ts';
import { useMemo } from 'react';
import {
    bucket,
    VolumeCurveBucketedDataItem,
} from 'widgets/volumeCurve/data/volumeCurveDataBuckets.ts';
import { useVolumeCurveConfigSlice } from 'widgets/volumeCurve/store/configuration/configSlice.ts';
import { VolumeCurveDataState } from 'widgets/volumeCurve/store/data/VolumeCurveDataState.ts';

export interface VolumeCurveData {
    tickSize: number | null | undefined;
    breaksInTrading: TimeSeriesDisableRange[];
    bucketedData: VolumeCurveBucketedDataItem[];
    startTimestamp: number;
    endTimestamp: number;
}

export const initialData: VolumeCurveData = {
    // arrivalTimestamp: 0,
    // timeCompleted: 0,
    bucketedData: [],
    breaksInTrading: [],
    tickSize: undefined,
    startTimestamp: 0,
    endTimestamp: 0,
};
export function buildVolumeCurveData(
    data: VolumeCurveDataState | undefined,
    barSizeInMinutes: number
) {
    if (!data || !data.orderStat) {
        return initialData;
    }

    const { timeSeries, disableRange } = data;

    const timeSeriesWithVolumeData = timeSeries.filter(
        (t) => t.vp !== undefined || t.v !== undefined || t.avp !== undefined
    );

    const sortedTimeSeries = timeSeriesWithVolumeData.sort((a, b) =>
        a._i > b._i ? +1 : -1
    );

    const breaksInTrading = mapFromElementRangeArray(disableRange);

    const buckets = bucket(barSizeInMinutes, sortedTimeSeries, breaksInTrading);

    const startTimestamp = buckets[0].startTime;
    const endTimestamp = buckets[buckets.length - 1].endTime;

    return {
        bucketedData: buckets,
        tickSize: barSizeInMinutes,
        startTimestamp,
        endTimestamp,
        breaksInTrading,
    };
}

export function useVolumeCurveData(): VolumeCurveData {
    const data = useVolumeCurveWidgetStreamedData()?.data;
    const {
        config: { barSizeInMinutes },
    } = useVolumeCurveConfigSlice();

    return useMemo(
        () => buildVolumeCurveData(data, barSizeInMinutes),
        [barSizeInMinutes, data]
    );
}
